import { HStack, Link, StackProps, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { StageFillIcon } from "@/stage/components/StagesIcon";
import { useStageColor } from "@/stage/hooks/useStagesColor";
import { StageDTO } from "@reflag/shared/stageAPI";
import { GlobalSettingsUrl } from "@reflag/shared/urls";

type Props = {
  stage: Pick<StageDTO, "name" | "color">;
  link?: boolean;
} & StackProps;

export const StageDisplayName = ({
  stage,
  link = false,
  ...stackProps
}: Props) => {
  const { env } = useEnvironment();
  const color = useStageColor(stage.color);

  const component = (
    <HStack spacing={1} {...stackProps}>
      <StageFillIcon boxSize={3} color={color} flexShrink={0} />
      <Text as="span" fontWeight="medium" isTruncated>
        {stage.name}
      </Text>
    </HStack>
  );

  if (link && env) {
    return (
      <Link
        as={RouterLink}
        style={{ textDecoration: "none" }}
        to={GlobalSettingsUrl(env, "app-stages")}
      >
        {component}
      </Link>
    );
  } else {
    return component;
  }
};
